module.exports = __webpack_public_path__ + "img/desc_time.c1bf49f9.png";